
import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { InputIcon } from 'primereact/inputicon';

export default function TabElement(props) {
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);
    const [open, setopen] = useState(props.openTab);

    const toggleOpen = () => {
        setopen(!open);
        props.setOpen(!open)
    };

    return (
        <div className="tab-element-wrapper">
            <TabView activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index); props.onTabChange(e)}} renderActiveOnly={false} className='custom-tabview d-flex'>
                {props.items.map((item, index) => {
                    const hasError = (props.errors != undefined && props.errors.length > 0) ? props.errors.includes(item.label) : false
                    return (
                        <TabPanel key={index} header={item.label} leftIcon={item.icon} headerClassName={hasError ? 'error-tab' : ''}>
                            {item.Component}
                        </TabPanel>
                    )
                })}
            </TabView>
            {
                props.mainModules &&
                <div className={open ? "icon-container" : "icon-left-container"}>
                    {
                        open ? (
                            <InputIcon
                                className="pi pi-angle-double-left pointer angle-portfolio"
                                onClick={toggleOpen}
                            />
                        ) : (
                            <InputIcon
                                className="pi pi-angle-double-right pointer angle-portfolio"
                                onClick={toggleOpen}
                            />
                        )
                    }
                </div>
            }
        </div>
    )
}